/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Facts_PlatformsInputs */

const en_vc_facts_platforms = /** @type {(inputs: Vc_Facts_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs on`)
};

const zh_vc_facts_platforms = /** @type {(inputs: Vc_Facts_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持平台`)
};

/**
* | output |
* | --- |
* | "Runs on" |
*
* @param {Vc_Facts_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_facts_platforms = /** @type {((inputs?: Vc_Facts_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Facts_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_facts_platforms(inputs)
	return zh_vc_facts_platforms(inputs)
});
export { vc_facts_platforms as "vc.facts.platforms" }